import { FormElementModel } from "../../../models/FormElementModel";
import { lengthValidator } from "../../../../utils/formsValidation";
import { t } from "i18next";

export const childRegisterForm = (register: any): FormElementModel[] => [
  {
    name: "name",
    type: "text",
    text: t("imie"),
    isLabel: true,
    register: { ...register("name", { ...lengthValidator(true, 2) }) },
  },
  {
    name: "lastName",
    type: "text",
    text: t("nazwisko"),
    isLabel: true,
    register: { ...register("lastName", { ...lengthValidator(true, 2) }) },
  },
  {
    name: "age",
    type: "number",
    text: t("wiek"),
    isLabel: true,
    register: { 
      ...register("age", { 
        required: t("pole_wymagane"),
        min: { value: 1, message: t("wiek_musi_byc_wiekszy_od_0") },
        valueAsNumber: true,
      }) 
    },
  },
];

